export const GTM_EVENTS = {
  PAGE_VIEW: {
    name: "cxp.pageview",
    displayName: "CXP Page View",
  },
};

type GTMEventKey = keyof typeof GTM_EVENTS;
type GTMEventType = (typeof GTM_EVENTS)[GTMEventKey];

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: Array<Record<string, any>>;
  }
}

export const gtmEvent = (
  event: GTMEventType,
  doc: Document,
  sessionId: string,
  userId?: string,
  email?: string,
  pageReferrer?: string,
  params?: Record<string, any>,
) => {
  if (typeof window === "undefined") return;

  if (!doc || !sessionId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event.name,
    event_category: "CXP App",
    event_label: event.displayName,
    page_path: document.location.pathname ?? "",
    page_location: document.location.href ?? "",
    page_title: document.title ?? "",
    sessionId,
    user_type: userId ? "signed in" : "guest",
    email: email ?? "",
    userId: userId ?? "",
    page_referrer: pageReferrer,
    ...params,
  });
};

export const pushData = (
  data: Record<string, any> | Array<Record<string, any>>,
) => {
  if (typeof window === "undefined" || !data) return;

  window.dataLayer = window.dataLayer || [];
  if (Array.isArray(data)) {
    window.dataLayer.push(...data);
  } else {
    window.dataLayer.push(data);
  }
};
